

export const SOLD_ITEMS_MARK_TO_RELOAD = "soldUpdatedAt";
export const ACTIVE_ITEMS_MARK_TO_RELOAD = "activeUpdatedAt";
